import { zodResolver } from "@hookform/resolvers/zod";
import { Box, Grid } from '@mui/material';
import { useCallback, useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { ContextOperacionNuevo, ContextOperacionNuevoType } from "../../NuevoSistema";
import { HttpAFOPU } from './api/httoAFOPU';
import { SeccionNuevoAFOPUDatosOperacion } from './components/SeccionNuevoAFOPUDatosOperacion';
import SeccionNuevoAFOPUTablaValores from './components/SeccionNuevoAFOPUTablaValores';
import { OperacionAFOPUInsert } from "./types/dto";
import { OperacionAFOPUFields } from "./types/fields";
import { FormOperacionAFOPU, schemaFormOperacionAFOPU } from "./types/types";
import { useSubmitOperacion } from "../../hooks/useSubmitOperacion";

interface NuevoSistemaAFOPUProps {
  codSistemaPrincipal: number,
}

const NuevoSistemaAFOPU = ({ codSistemaPrincipal }: NuevoSistemaAFOPUProps) => {
  const { submitOperacion } = useSubmitOperacion();

  const formMethods = useForm<FormOperacionAFOPU>({
    resolver: zodResolver(schemaFormOperacionAFOPU),
    defaultValues: {
      [OperacionAFOPUFields.FechaSolicitud]: new Date(),
      [OperacionAFOPUFields.CodPais]: codSistemaPrincipal,
      [OperacionAFOPUFields.TablaValores]: []
    }
  })

  const handleCrearOperacion = useCallback(
    (data: OperacionAFOPUInsert) => {
      submitOperacion(data, {
        apiCall: HttpAFOPU.post,
        codSistemaPrincipal,
      });
    },
    [codSistemaPrincipal, submitOperacion]
  );

  const { setSavePromise, setSendPromise, codSistema } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

  useEffect(() => {
    const onSend = () => formMethods.handleSubmit(data => handleCrearOperacion(data))
    setSendPromise(onSend)
  }, [formMethods, handleCrearOperacion])

  return (
    <Box>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionNuevoAFOPUDatosOperacion formMethods={formMethods} codSistemaPrincipal={codSistemaPrincipal} codSistema={codSistema} />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoAFOPUTablaValores formMethods={formMethods} codSistemaPrincipal={codSistemaPrincipal} />
        </Grid>
      </Grid>
    </Box>
  )
}

export default NuevoSistemaAFOPU
